export default {
  path: '/appManage',
  name: 'appManage',
  component: () => import('../../views/Layout/index'),
  meta: {
    title: '应用管理',
  },
  children: [
    {
      // 账户管理
      path: 'index',
      name: 'appManageIndex',
      component: () => import('../../views/AppManage/AppManage'),
      meta: { title: '应用管理', keepAlive: false }
    }
  ]
}